import React, { FC } from 'react'

import styled from 'styled-components'

import { WithDataName } from 'common/types'
import { Colors } from 'common-constants/colors'
import { media } from 'components/presentational'
import { ProfileName } from 'components/presentational/ProfileName/ProfileName'
import { GQLGender } from 'generated-graphql/graphql'

import { UserLocationAbTest } from './UserLocationAbTest'

export const InfoProfile: FC<
  {
    name: string
    age: number | null | undefined
    isOnline: boolean | undefined
    hasVerification: boolean
    spaceTimeLocationRelation: string
    location: string
    gender: GQLGender
    iconUid?: string
    nameInCenter?: boolean
  } & WithDataName
> = ({
  name,
  age,
  location,
  spaceTimeLocationRelation,
  isOnline,
  hasVerification,
  gender,
  iconUid,
  nameInCenter,
  ...rest
}) => (
  <WrapInfo data-name={rest['data-name']}>
    <StyledProfileName
      fullName={name}
      age={age}
      statusVerification={hasVerification}
      online={isOnline}
      gender={gender}
      nameIsTwoRow={true}
      nameInCenter={nameInCenter}
      iconUid={iconUid}
    />

    <UserLocationAbTest
      location={spaceTimeLocationRelation || location}
      online={isOnline!}
      gender={gender}
    />
  </WrapInfo>
)

export const WrapInfo = styled.div`
  margin-bottom: 40px;
  position: relative;

  ${media.tablet`    
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    text-align: center;
  `}
`

export const StyledProfileName = styled(ProfileName)`
  font-size: 26px;
  color: ${Colors.dark};

  ${media.tablet`
    color: ${Colors.white}; 
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    justify-content: center;
  `}
`
